// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "static/js/8cf76fe241fbd7b30781.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"227da8bb41eed492e112","181":"3c69447c26f9cafa5d26","182":"a3a6ffadafa135024d7f"}[chunkId] + ".chunk.js";
};